module.exports = __webpack_public_path__ + "assets/img/01-b5171ad6.jpg";